
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pricing",
      function () {
        return require("private-next-pages/pricing/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pricing"])
      });
    }
  